import { getAreas } from '@/shared/services/areaService'
import { getReviews } from '@/shared/services/reviewService'

export default {
  namespaced: true,
  state: {
    reviews: [],
    areas: [],
    canLoadMore: false,
  },
  getters: {},
  mutations: {
    SET_REVIEWS(state, reviews) {
      state.reviews = reviews
    },
  
    SET_AREAS(state, areas) {
      state.areas = areas
    },

    SET_CAN_LOAD_MORE(state, canLoadMore) {
      state.canLoadMore = canLoadMore
    },
  },
  actions: {
    async fetchReviews(ctx, { areaId, action }) {
      try {
        const reviewsState = ctx.state.reviews
        let mileStone

        if (reviewsState?.length && action) {
          mileStone = action === 'next' ? reviewsState.at(-1).date : reviewsState.at(1).date
        }

        const reviews = await getReviews(areaId, action, mileStone)
        
        ctx.commit('SET_CAN_LOAD_MORE', reviews?.length === 20)

        return ctx.commit('SET_REVIEWS', reviews)
      } catch (error) {
        return Promise.reject(error)
      }
    },

    // TODO: remove when use appArea/areas
    async fetchAreas(ctx, { accountId }) {
      try {
        const areas = await getAreas(accountId)
        
        // Filter here but not in DB level because each account only have about 1-50 areas; and in the future we'll use appArea state instead of fetching everytime
        return ctx.commit('SET_AREAS', areas?.filter(area => area.reviews?.length).map(item => ({ id: item.id, name: item.name, reviews: item.reviews })))
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
